import FCellDateTimeMDP from "@/components/table/cell/FCellDateTimeMDP";
import FCellPhoneMDP from "@/components/table/cell/FCellPhoneMDP";
import FDataTableMDP from "@/components/table/FDataTableMDP";

export default class UnverifiedClientListFDataTableMDP extends FDataTableMDP {
  parent: any;
  constructor(props: { parent: any }) {
    super({
      myRefName: "unverifiedClientListFDataTableRef",
      enableSearch: true,
      title: "Unverified Client File List",
      enableShowHideColumns: true,
      itemKey: "clientFileNumber",
      multiSelect: true,
    });
    this.parent = props.parent;
    this.addClientNameColumn({
      dataSelectorKey: "fullName",
    })
      .addColumn({
        label: "PHONE",
        dataSelectorKey: "mobile",
        columnCellMDP: new FCellPhoneMDP(),
      })
      .addColumn({
        label: "Program Code",
        dataSelectorKey: "programCode.name",
      })
      .addColumn({
        label: "Unique Referral Code",
        dataSelectorKey: "uniqueReferralCode",
      })
      .addColumn({
        label: "Registered On",
        dataSelectorKey: "registeredOn",
        columnCellMDP: new FCellDateTimeMDP(),
      });
  }
  handleAssignClick(item: any) {
    return new Promise((resolve) => {
      this.parent.handleAssignClick(item);
    });
  }

  handlePartnerNameClick(item: any) {
    this.parent.gotoPartnerDetails(item.partnerId);
  }
}
